import { render, staticRenderFns } from "./DetailsProposal.vue?vue&type=template&id=e3206e50"
import script from "./DetailsProposal.vue?vue&type=script&lang=js"
export * from "./DetailsProposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports